




import enterpriseTemplateH5 from "./templates/enterpriseTemplateH5.vue";
import doctorTemplateH5 from "./templates/doctorTemplateH5.vue";
export default {
  name: "aiwen-register-h5",
  components: {
    enterpriseTemplateH5,
    doctorTemplateH5,
  },
  computed: {
    currentComponent() {
      console.log((this as any).$attrs, "this.$attrs init");
      interface IbusinessTypeObj {
        [propName: string]: any;
      }
      const businessTypeObj: IbusinessTypeObj = {
        biz: "enterpriseTemplateH5",
        doctor: "doctorTemplateH5",
      };
      return businessTypeObj[(this as any).$attrs.config.businessType];
    },
  },
};
